// Lessons.js
import React from 'react';
import "./Lessons.css";
import Common_breadcrumb from '../common_components/common-breadcrumb/Common_breadcrumb';
import Lessons_card from './Lessons_card/Lessons_card';

const Lessons = () => {
    const breadcrumbsData = [
        { name: "HOMEPAGE", href: "/" },
        { name: "COURSES", active: true }
    ];

    // Array of lesson data
   const lessonsData = [
  {
    imgSrc: "/assets/images/lesson/lesson_cards_img/img_1.png",
    title: "01. Traffic Signs & Road Markings",
    description:
      "A foundational module that helps learners identify and understand major traffic signs, signals, and road markings used across India. This course improves visual recognition, explains sign categories, and trains learners to interpret road indicators correctly for safe and lawful driving.",
    // duration: "10 Days (1 Hour Daily)",
    // outcome: "Confidence to handle a car in low-traffic conditions",
  },
  {
    imgSrc: "/assets/images/lesson/lesson_cards_img/img_2.png",
    title: "02. Defensive Driving",
    description:
      "This module teaches proactive driving techniques to help prevent accidents and handle unexpected road situations. Learners explore hazard anticipation, lane discipline, safe distance management, speed control, and techniques for navigating Indian road challenges safely and confidently.",
    // duration: "10 Days (1 Hour Daily)",
    // outcome: "Confidence to handle a car in low-traffic conditions",
  },
  {
    imgSrc: "/assets/images/lesson/lesson_cards_img/img_3.png",
    title: "03. Vehicle Mechanics",
    description:
      "Designed to enhance technical awareness, this module covers essential vehicle components, routine maintenance, dashboard warning indicators, and basic troubleshooting. Learners understand how their vehicle operates and how to keep it road-ready.",
    // duration: "10 Days (1 Hour Daily)",
    // outcome: "Confidence to handle a car in low-traffic conditions",
  },
  {
    imgSrc: "/assets/images/lesson/lesson_cards_img/img_4.png",
    title: "04. RTO Documents & Test Preparation",
    description:
      "A comprehensive guide to essential RTO documents, licensing requirements, PUC, RC, and other important paperwork. This module also includes structured preparation material for the learner’s licence test, helping learners understand rules, procedures, and expectations.",
    // duration: "10 Days (1 Hour Daily)",
    // outcome: "Confidence to handle a car in low-traffic conditions",
  },
  {
    imgSrc: "/assets/images/lesson/lesson_cards_img/img_5.png",
    title: "05. Practice Question Bank",
    description:
      "A collection of extensive practice questions based on actual RTO exam patterns. Learners can test their knowledge of road rules, signs, and safety guidelines with instant feedback to identify areas for improvement.",
    // duration: "10 Days (1 Hour Daily)",
    // outcome: "Confidence to handle a car in low-traffic conditions",
  },
  {
    imgSrc: "/assets/images/lesson/lesson_cards_img/img_6.png",
    title: "06. Mock Test",
    description:
      "A simulated learner’s licence test designed to replicate the real RTO exam experience. This module helps learners assess their readiness, build confidence, and improve accuracy under timed conditions.",
    // duration: "10 Days (1 Hour Daily)",
    // outcome: "Confidence to handle a car in low-traffic conditions",
  },
];


    return (
        <>
            <Common_breadcrumb
                pageName="COURSES"
                bgImage="/assets/images/lesson/bg/bg.png"
                breadcrumbs={breadcrumbsData}
            />
            <div className="card_section">
                <div className="container">
                    <div className="card_section_holder">
                        <div className="row">
                            {lessonsData.map((lesson, index) => (
                                <div className="col-md-6" key={index}>
                                    <Lessons_card
                                        imgSrc={lesson.imgSrc}
                                        title={lesson.title}
                                        description={lesson.description}
                                        duration={lesson.duration}
                                        outcome={lesson.outcome}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Lessons;
